import React from "react";
import {
  IconBrandLinkedin,
  IconBrandFacebook,
  IconBrandX,
  IconBrandWhatsapp,
} from "@tabler/icons-react";

const SITE_URL = "https://gxleng.com";

const ShareButtons = ({ url, title, description = "", variant = "dark" }) => {
  const fullUrl = url.startsWith("http") ? url : `${SITE_URL}${url}`;
  const encodedUrl = encodeURIComponent(fullUrl);
  const encodedTitle = encodeURIComponent(title);
  const encodedText = encodeURIComponent(`${title}${description ? ` - ${description}` : ""}`);

  const isLight = variant === "light";

  const shareLinks = [
    {
      name: "LinkedIn",
      icon: IconBrandLinkedin,
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`,
      hoverClass: "hover:bg-[#0A66C2] hover:border-[#0A66C2] hover:text-white",
    },
    {
      name: "Facebook",
      icon: IconBrandFacebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      hoverClass: "hover:bg-[#1877F2] hover:border-[#1877F2] hover:text-white",
    },
    {
      name: "X",
      icon: IconBrandX,
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      hoverClass: "hover:bg-black hover:border-black hover:text-white",
    },
    {
      name: "WhatsApp",
      icon: IconBrandWhatsapp,
      url: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
      hoverClass: "hover:bg-[#25D366] hover:border-[#25D366] hover:text-white",
    },
  ];

  const handleShare = (shareUrl, name) => {
    const width = 600;
    const height = 400;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;
    window.open(
      shareUrl,
      `share-${name}`,
      `width=${width},height=${height},left=${left},top=${top},toolbar=0,menubar=0,location=0`
    );
  };

  const labelClass = isLight ? "text-gray-600" : "text-[rgb(171,174,187)]";
  const buttonBaseClass = isLight
    ? "border-gray-400 text-gray-700"
    : "border-[rgba(255,255,255,0.2)] text-white";

  return (
    <div className="flex items-center gap-3">
      <span className={`text-sm ${labelClass}`}>Share:</span>
      <div className="flex gap-2">
        {shareLinks.map((link) => {
          const Icon = link.icon;
          return (
            <button
              key={link.name}
              onClick={() => handleShare(link.url, link.name)}
              aria-label={`Share on ${link.name}`}
              className={`w-9 h-9 rounded-full border bg-transparent flex items-center justify-center transition-all duration-300 ${buttonBaseClass} ${link.hoverClass}`}
            >
              <Icon size={18} stroke={1.5} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ShareButtons;
